import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteWaitlistEntry } from '../../store/thunks/waitlistThunks';
import Table from '../shared/Table';

const WaitlistList = ({ waitlist, loading, onRefresh }) => {
  const dispatch = useDispatch();

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this waitlist entry?')) {
      await dispatch(deleteWaitlistEntry(id));
      onRefresh();
    }
  };

  const columns = [
    {
      header: 'Email',
      accessor: 'email',
      Cell: ({ row }) => <span className="font-medium">{row.original.email}</span>
    },
    {
      header: 'Created At',
      accessor: 'createdAt',
      Cell: ({ row }) => {
        const date = new Date(row.original.createdAt);
        return (
          <div className="flex flex-col">
            <span className="font-medium">{date.toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'short', 
              day: 'numeric' 
            })}</span>
            <span className="text-xs text-gray-500">{date.toLocaleTimeString('en-US', { 
              hour: '2-digit', 
              minute: '2-digit'
            })}</span>
          </div>
        );
      }
    },
    {
      header: 'Actions',
      accessor: '_id',
      Cell: ({ row }) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleDelete(row.original._id)}
            className="p-2 bg-red-100 text-red-600 hover:bg-red-200 rounded-lg transition-colors"
            title="Delete"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      )
    }
  ];

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#B85C38]"></div>
      </div>
    );
  }

  if (!waitlist || waitlist.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No waitlist entries found. Add a new entry to get started.
      </div>
    );
  }

  return <Table columns={columns} data={waitlist} />;
};

export default WaitlistList;
